import { JobItemStatus } from '../types';

export type JobStatusCellCssOptions = {
  errors?: boolean;
  status?: JobItemStatus;
};

export type JobStatusCellCss = {
  jobCellCss: string;
  jobCellItem: string;
  jobCellLoadingIcon: string;
  jobCellText: string;
  jobCellIcon: string;
};

export const jobStatusCellCss = ({
  errors,
  status,
}: JobStatusCellCssOptions = {}): JobStatusCellCss => {
  const jobCellCss: string[] = ['job-status-cell'];
  const jobCellIcon: string[] = ['job-status-cell__icon'];
  const jobCellItem: string[] = ['job-status-cell__item'];
  const jobCellLoadingIcon: string[] = ['job-status-cell__loading-icon'];
  const jobCellText: string[] = ['job-status-cell__text'];

  if (errors) {
    jobCellIcon.push('job-status-cell__icon--alert');
  }

  if (status === 'Failed') {
    jobCellIcon.push('job-status-cell__icon--error');
  }

  return {
    jobCellCss: jobCellCss.join(' '),
    jobCellIcon: jobCellIcon.join(' '),
    jobCellItem: jobCellItem.join(' '),
    jobCellLoadingIcon: jobCellLoadingIcon.join(' '),
    jobCellText: jobCellText.join(' '),
  };
};
